import { api, type ApiResponse } from '@/lib/api';
import type {
  GamificationConfig,
  GamificationEventListItem,
  GamificationEventsQuery,
  GamificationEventsSummary,
  ListResponse,
  UpdateGamificationConfigRequest,
} from '@troia-v3/types';

/** Cliente HTTP do módulo de gamificação (`/api/gamification/*`, Parte 4). */
export const gamificationApi = {
  async getConfig(): Promise<GamificationConfig> {
    const res = await api.get<ApiResponse<GamificationConfig>>('/gamification/config');
    return res.data.data!;
  },
  async updateConfig(patch: UpdateGamificationConfigRequest): Promise<GamificationConfig> {
    const res = await api.put<ApiResponse<GamificationConfig>>('/gamification/config', patch);
    return res.data.data!;
  },
  async listEvents(query: GamificationEventsQuery): Promise<ListResponse<GamificationEventListItem>> {
    const res = await api.get<ApiResponse<ListResponse<GamificationEventListItem>>>('/gamification/events', { params: query });
    return res.data.data!;
  },
  async getEventsSummary(periodKey?: string): Promise<GamificationEventsSummary> {
    const res = await api.get<ApiResponse<GamificationEventsSummary>>('/gamification/events/summary', { params: periodKey ? { periodKey } : {} });
    return res.data.data!;
  },
};
